import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ReportTools} from './reportTools.js';


/* global customElements */
class CloseReportsGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var closeReportsGrid = this;
		setTimeout(function(){
			closeReportsGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var closeReportsGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},				
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['CLOSE_REPORTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['CLOSE_REPORTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'manageReports',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['CLOSE_REPORTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:file-text', ' Manage Reports')						
					],
					listeners: {
						click: function() {
							actionManageReports(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'runs',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['CLOSE_REPORTS:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:play-circle', ' Runs')						
					],
					listeners: {
						click: function() {
							actionRuns(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',						
					theme: '',
					itemid: 'toggleStatus',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['CLOSE_REPORTS:UPDATE_STATUS'],
					children:[
						ElementUtil.makeIcon('vaadin:exchange', ' Toggle Status')
					],
					listeners: {
						click: function() {
							actionToggleStatus(grid.selectedItems[0]);
						}
					}
				}									
			]
		});		
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'closeReportSetId',
					header: 'Set Id',
					width: '7em'
				},
				{						
					path: 'reportSetName',
					header: 'Set Name',
					width: '7em'
				},	
				{						
					path: 'intervalDescription',
					header: 'Close Report Interval',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'emailAddresses',
					header: 'Email Addresses',					
					width: '7em'
				},
				{						
					path: 'reminderDays',					
					header: 'Reminder Days',
					'text-align': 'center',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.reminderDays) {
							root.innerHTML = rowData.item.reminderDays;
						} else {
							root.innerHTML = 'No Reminder';
						}
					}
				},
				{						
					path: 'lastReminderSentDts',
					header: 'Last Reminder Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.lastReminderSentDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},								
				{						
					path: 'updateUser',
					header: 'Update User',
					width: '7em'
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'manageReports').disabled = false;		
						ElementUtil.query(toolbar, 'runs').disabled = false;		
						ElementUtil.query(toolbar, 'toggleStatus').disabled = false;		
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;				
						ElementUtil.query(toolbar, 'manageReports').disabled = true;		
						ElementUtil.query(toolbar, 'runs').disabled = true;		
						ElementUtil.query(toolbar, 'toggleStatus').disabled = true;							
					}
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		closeReportsGrid.append(flexLayout);		
			
		var actionRefresh = function() {	
			var loadMask = grid.showLoading();
			Service.getReportService().getCloseReports({
				status: ElementUtil.query(toolbar, 'status').value
			}).then(function(sets){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = sets.data;	
			});			
		};
		actionRefresh();
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Close Report Set' : 'Add Close Report Set',
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',										
											name: 'reportSetName',
											label: 'Set Name',
											required: true,
											maxLength: 255											
										},
										{
											tag: 'vaadin-combo-box',
											label: 'Reporting Interval',
											name: 'closeReportInterval',
											'item-value-path': 'code',
											'item-label-path': 'description',											
											value: 'MONTHLY',
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('CloseReportInterval').then(function (data) {
													combo.items = data;
													combo.required = true;
												});
											}
										},	
										{
											tag: 'vaadin-text-field',										
											name: 'emailAddresses',
											label: 'Email Addresses',
											'helper-text': 'comma-separated',
											maxLength: 255											
										},																			
										{
											tag: 'vaadin-number-field',										
											name: 'reminderDays',
											label: 'Send Reminder X Days Before Close Period',	
											'helper-text': 'Add value to set reminder',
											max: 30,
											min: 1
										},								
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {																	
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.closeReportSetId = record.closeReportSetId;
																	}
																	return Service.getReportService().saveCloseReport(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Close Report Set', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {	
							formPanel.load(record);							
						}
					}
				}
			});			
		};
		
		var actionToggleStatus = function(record) {
			
			if (record.activeStatus === 'A') {
				var loadMask = grid.showLoading('Inactivating...');
				Service.getReportService().inactivateCloseReport(record.closeReportSetId).then(function(data){
					loadMask.remove();
					
					actionRefresh();
				});				
			} else {
				var loadMask = grid.showLoading('Activating...');
				Service.getReportService().activateCloseReport(record.closeReportSetId).then(function(data){
					loadMask.remove();
					
					actionRefresh();
				});	
			}
						
		};
		
		var actionManageReports = function(record) {
			var manageWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Manage Reports',
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						manageWin.show();
						
						var reportToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'dl-action-button',
									itemid: 'add',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									permissions: ['CLOSE_REPORTS:WRITE'],
									children: [
										ElementUtil.makeIcon('vaadin:plus', ' Add')
									],
									listeners: {
										click: function () {
											actionAddReport();
										}
									}
								},
								{
									tag: 'dl-action-button',
									itemid: 'view',								
									'class': 'spacer-toolbar-item',
									permissions: ['CLOSE_REPORTS:READ'],
									children: [
										ElementUtil.makeIcon('vaadin:file-text', ' View Details')
									],
									listeners: {
										click: function () {
											actionViewReport(reportGrid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'span',
									innerHTML: '|'
								},
								{
									tag: 'dl-action-button',
									itemid: 'toggleAttach',								
									'class': 'spacer-toolbar-item',
									permissions: ['CLOSE_REPORTS:WRITE'],
									children: [
										ElementUtil.makeIcon('vaadin:exchange', ' Toggle Attach')
									],
									listeners: {
										click: function () {
											actionToggleAttach(reportGrid.selectedItems[0]);
										}
									}
								},
								{
									tag: 'div',
									style: 'float: right;',
									children: [																				
										{
											tag: 'dl-action-button',
											itemid: 'delete',
											theme: 'error primary',
											permissions: ['CLOSE_REPORTS:DELETE'],
											'class': 'spacer-toolbar-item',
											children: [
												ElementUtil.makeIcon('vaadin:trash', ' Delete')
											],
											listeners: {
												click: function () {
													actionDeleteReport(reportGrid.selectedItems[0]);
												}
											}
										}
									]
								}
							]
						});
						
						var reportGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true,
								listeners: {
									'direction-changed': function (event) {
										if (event.detail && event.detail.value) {
											reportGrid.currentSortField = event.target.path;
											reportGrid.currentSortDirection = event.detail.value.toUpperCase();											
										}
									}
								}
							},
							children: [
								{
									path: 'reportDescription',
									header: 'Report',
									width: '7em'
								},
								{
									path: 'unitSelectionTypeDescription',
									header: 'Unit Selection Type',
									'text-align': 'center',
									width: '7em',
									renderer: function(root, column, rowData) {
										if (rowData.item.unitSelectionTypeDescription) {
											root.innerHTML = rowData.item.unitSelectionTypeDescription;
										} else {
											root.innerHTML = 'N/A';
										}
									}
								},
								{
									path: 'attachReport',
									header: 'Attach Report',
									'text-align': 'center',
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									reportGrid.selectedItems = item ? [item] : [];
									if (reportGrid.selectedItems.length > 0) {									
										ElementUtil.query(reportToolbar, 'view').disabled = false;
										ElementUtil.query(reportToolbar, 'toggleAttach').disabled = false;
										ElementUtil.query(reportToolbar, 'delete').disabled = false;
									} else {										
										ElementUtil.query(reportToolbar, 'view').disabled = true;
										ElementUtil.query(reportToolbar, 'toggleAttach').disabled = true;
										ElementUtil.query(reportToolbar, 'delete').disabled = true;
									}
								}
							}
						});	
																	
						var reportFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								reportToolbar,
								reportGrid
							]
						});	
						
						manageWin.addToContentElement(reportFlexLayout);							
					
						var actionDetailRefresh = function() {
							var loadMask = reportGrid.showLoading();
							Service.getReportService().getCloseSetReports(record.closeReportSetId).then(function(data){
								loadMask.remove();
								
								reportGrid.activeItem = null;															
								reportGrid.items = data;		
							}).catch(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToastError('Failed to load Reports');
							});
						};
						actionDetailRefresh();
						
						var actionAddReport = function() {
							
							var generateWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Create Report Template',
								icon: 'vaadin:modal-list',
								width: .70,
								height: .70,
								listeners: {
									ready: function () {
										generateWin.show();

										var genForm = ElementUtil.create({
											tag: 'dl-report-generate-form',
											options: JSON.stringify({
												saveText: 'Add Template',
												closeReport: true
											}),
											postinit: function(templateForm) {
												templateForm.saveHandler = function(data) { 																								

													var submissionModel = {
														closeReportSetId: record.closeReportSetId,
														reportSubmissionModel: data,
														attachReport: false
													};

													var loadMask = reportGrid.showLoading('Adding...');
													Service.getReportService().addReportCloseReportSet(record.closeReportSetId, submissionModel).then(function () {
														loadMask.remove();

														actionDetailRefresh();
														generateWin.close();
													});
												};
											},
											listeners: {
												cancel: function () {
													generateWin.close();
												}
											}
										});
										
										generateWin.addToContentElement(genForm);
									}
								}
							});												
							
						};
						
						var actionViewReport = function(selectedReport) {
							
							//load details and render
							var detailWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Details',
								icon: 'vaadin:modal-list',				
								width: .70,
								height: .70,
								listeners: {
									ready: function() {						
										detailWin.show();

										var detailTable = ElementUtil.create({
											tag: 'dl-detail-table',
											itemid: 'detailtable',
											slot: 'primary'
										});

										var updateDetails = function(detail) {
											var data = [
												{
													key: 'Report',
													value: '-',
													section: true
												},			
												{
													key: 'Report Template Id',
													value: detail.reportId
												},											
												{
													key: 'Report',
													value: detail.reportType
												},
												{
													key: 'Report Description',
													value: detail.reportTypeDescription
												},
												{
													key: 'Unit Selection Type',
													value: detail.unitSelectionTypeDescription ? detail.unitSelectionTypeDescription : 'N/A'
												},												
												{
													key: 'Note',
													value: detail.note
												},																								
												{
													key: 'Create User',
													value: detail.createUser
												},
												{
													key: 'Create Date',
													value: TimeUtil.formatDateStandard(detail.createDts)
												},
												{
													key: 'Update User',
													value: detail.updateUser
												},
												{
													key: 'Last Update Date',
													value: TimeUtil.formatDateStandard(detail.updateDts)
												}					
											];						
											
											//outputs
											data.push({
													key: 'Outputs',
													value: '-',
													section: true
											});
											detail.outputs.forEach(function(output) {
												data.push({
													key: 'Transmission Type',
													value: output.transmissionType
												});
												data.push({
													key: 'Format',
													value: output.format
												});

												data.push({
													key: 'Output Options',
													value: '-------------'
												});

												for (var key in output.options) {
													data.push({
														key: key,
														value: output.options[key]
													});
												}

											});

											if (!ElementUtil.isEmpty(detail.options)) {
												data.push({
													key: 'Options',
													value: '-',
													section: true
												});

												for (var key in detail.options) {
													data.push({
														key: key,
														value: detail.options[key]
													});
												}
											}

											detailTable.updateDetails(data);
																
										};

										var detailedLayout = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [							
												detailTable
											]
										});	

										var unitsGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',			
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},			
											children: [
												{						
													path: 'referenceTypeDescription',
													header: 'Reference Type',
													width: '7em'
												},
												{						
													path: 'referenceNo',
													header: 'Unit Reference No',
													width: '7em'
												},
												{						
													path: 'unitId',
													header: 'Unit Id',
													width: '7em'
												},
												{						
													path: 'reportingPeriods',
													header: 'Reporting Periods',
													width: '12em',
													renderer: function(root, column, rowData) {
														if (rowData.item.reportingPeriods && rowData.item.reportingPeriods.length > 0) {
															var timeperiods = [];
															rowData.item.reportingPeriods.forEach(function(rp){
																var startDate = TimeUtil.parseDate(rowData.item.startDts);	
																var endDate = TimeUtil.parseDate(rowData.item.endDts);														
																timeperiods.push(
																	'Start: ' + TimeUtil.formatDateStandard(startDate) + '<br>' +  													
																	'End: '  + TimeUtil.formatDateStandard(endDate)
																);
															});

															root.innerHTML = timeperiods.join('<br><br>');					
														} else {
															root.innerHTML = 'N/A';
														}
													}
												}
											]
										});

										var unitPagingToolbar = ElementUtil.create({
											tag: 'dl-paging-toolbar',
											slot: 'footer',
											pageSize: 50,
											postinit: function(element) {
												element.grid = unitsGrid;
												element.loader = function(backingGrid, pageNumber, pagebar) {
													var pageRange = pagebar.pullRange();
													var loadMask = unitsGrid.showLoading();

													var loadData = function() {

														unitsGrid.currentFilter = {
															offset: pageRange.offset,
															max: pageRange.max,
															sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
															sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC'
														};


														var successHandler = function(records) {
															loadMask.remove();
															unitsGrid.activeItem = null;						
															unitsGrid.items = records.data;

															unitPagingToolbar.totalRecords = records.totalNumber;
															unitPagingToolbar.updatePager();						
														};

														Service.getReportService().getCloseReportUnits(selectedReport.closeReportSetId, selectedReport.closeReportDetailId, unitsGrid.currentFilter).then(function(records){
															successHandler(records);
														});						
													};	

													loadData();
												};
											},
											listeners: {
												ready: function() {					
													unitPagingToolbar.loadCurrentPage();					
												}
											}

										});							

										var unitLayout = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [							
												unitsGrid,
												unitPagingToolbar
											]
										});

										var groupsGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true
											},
											children: [
												{
													path: 'groupName',
													header: 'Group Name',
													flexGrow: 1
												},
												{
													path: 'groupCode',
													header: 'Group Code',
													width: '8em'
												},
												{
													path: 'tagExpression',
													header: 'Tag Expression',
													width: '12em'
												}
											]
										});

										var groupPagingToolbar = ElementUtil.create({
											tag: 'dl-paging-toolbar',
											slot: 'footer',
											pageSize: 50,
											postinit: function(element) {
												element.grid = groupsGrid;
												element.loader = function(backingGrid, pageNumber, pagebar) {
													var pageRange = pagebar.pullRange();
													var loadMask = groupsGrid.showLoading();

													groupsGrid.currentFilter = {
														offset: pageRange.offset,
														max: pageRange.max,
														sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'groupName',
														sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC'
													};

													var successHandler = function(records) {
														loadMask.remove();
														groupsGrid.activeItem = null;
														groupsGrid.items = records.data;

														groupPagingToolbar.totalRecords = records.totalNumber;
														groupPagingToolbar.updatePager();
													};

													Service.getReportService().getCloseReportBulkGroups(selectedReport.closeReportSetId, selectedReport.closeReportDetailId, groupsGrid.currentFilter).then(function(records){
														successHandler(records);
													});
												};
											},
											listeners: {
												ready: function() {
													groupPagingToolbar.loadCurrentPage();
												}
											}
										});

										var groupLayout = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [
												groupsGrid,
												groupPagingToolbar
											]
										});

										var tabPanel = ElementUtil.create({
											tag: 'dl-tabpanel',
											listeners: {
												ready: function(e) {									
													tabPanel.addTabs([
														{
															'tab-title': 'Report',
															tag: 'div',
															style: 'height: 100%;',
															children: [														
																detailedLayout												
															]
														},
														{
															'tab-title': 'Custom Units',
															tag: 'div',
															style: 'height: 100%;',
															children: [		
																unitLayout
															]
														},
														{
															'tab-title': 'Groups',
															tag: 'div',
															style: 'height: 100%;',
															children: [
																groupLayout
															]
														}
													]);
												}
											}
										});

										detailWin.addToContentElement(tabPanel);

										//pull Details
										Service.getReportService().getCloseSetReportTemplate(selectedReport.closeReportSetId, selectedReport.closeReportDetailId).then(function(details){
											updateDetails(details);
										});

									}
								}
							});
							
						};
						
						var actionToggleAttach = function(selectedReport) {
							var loadMask = reportGrid.showLoading();
							Service.getReportService().toggleAttachCloseReport(selectedReport.closeReportSetId, selectedReport.closeReportDetailId).then(function(data){
								loadMask.remove();
								actionDetailRefresh();								
							});
						};
						
						var actionDeleteReport = function(selectedReport) {
							
							window.DL.MessageUtil.showConfirm({
								title: 'Confirm Delete',
								message: 'Are you sure you want to remove the selected report from set?',
								buttons: [
									{
										text: 'Yes',
										handler: function() {
											var loadMask = grid.showLoading('Removing...');

											Service.getReportService().deleteCloseSetReportTemplate(selectedReport.closeReportSetId, selectedReport.closeReportDetailId)
											.then(function(){
												loadMask.remove();
												window.DL.MessageUtil.showToast('Success', 'Removed', {									
													theme: 'success'
												});
												actionDetailRefresh();
											});						
										}
									},
									{
										text: 'No'
									}
								]
							});
							
						};						
											
					}
				}
			});
		};
		
		var actionRuns = function(record) {
			var runWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Runs for ' + record.reportSetName,
				icon: 'vaadin:edit',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						runWin.show();
						
						var reportToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'vaadin-button',
									itemid: 'refresh',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
									], 
									listeners: {
										click: function() {
											actionRefreshRuns();
										}
									}
								},
								{
									tag: 'dl-action-button',
									itemid: 'newRun',
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									permissions: ['CLOSE_REPORTS:WRITE'],
									children: [
										ElementUtil.makeIcon('vaadin:play', ' New Run')
									],
									listeners: {
										click: function () {
											actionNewRun();
										}
									}
								},
								{
									tag: 'span',
									innerHTML: '|'
								},
								{
									tag: 'dl-action-button',
									itemid: 'view',								
									'class': 'spacer-toolbar-item',
									permissions: ['CLOSE_REPORTS:READ'],
									children: [
										ElementUtil.makeIcon('vaadin:file-text', ' View Details')
									],
									listeners: {
										click: function () {
											actionViewDetails(runGrid.selectedItems[0]);
										}
									}
								}
							]
						});
						
						var runGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},
							children: [
								{
									path: 'year',
									header: 'Year',
									'text-align': 'center',
									width: '7em'
								},
								{
									path: 'quarterDescription',
									header: 'Quarter',
									'text-align': 'center',
									width: '7em'
								},
								{
									path: 'monthDescription',
									header: 'Month',
									'text-align': 'center',
									width: '7em'
								},								
								{
									path: 'emailWhenComplete',
									header: 'Email On Complete',
									'text-align': 'center',
									width: '7em'
								},
								{
									path: 'lockPeriodWhenComplete',
									header: 'Lock On Complete',
									'text-align': 'center',
									width: '7em'
								},
								{
									path: 'runStatusDescription',
									header: 'Status',
									'text-align': 'center',
									width: '7em'
								},
								{
									path: 'comment',
									header: 'Comment',									
									width: '7em'
								}
							],
							listeners: {
								'active-item-changed': function (event) {
									const item = event.detail.value;
									runGrid.selectedItems = item ? [item] : [];
									if (runGrid.selectedItems.length > 0) {									
										ElementUtil.query(reportToolbar, 'view').disabled = false;
									} else {										
										ElementUtil.query(reportToolbar, 'view').disabled = true;
									}
								}
							}
						});

						var runPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 50,
							postinit: function (element) {
								element.grid = runGrid;
								element.loader = function (backingGrid, pageNumber, pagebar) {
									var pageRange = pagebar.pullRange();
									var loadMask = runGrid.showLoading();

									var loadData = function () {

										runGrid.currentFilter = {
											offset: pageRange.offset,
											max: pageRange.max,
											sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
											sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'DESC'
										};


										var successHandler = function (records) {
											loadMask.remove();
											runGrid.activeItem = null;
											runGrid.items = records.data;

											runPagingToolbar.totalRecords = records.totalNumber;
											runPagingToolbar.updatePager();
										};

										Service.getReportService().getCloseReportRuns(record.closeReportSetId, runGrid.currentFilter).then(function (records) {
											successHandler(records);
										});
									};

									loadData();
								};
							},
							listeners: {
								ready: function () {
									runPagingToolbar.loadCurrentPage();
								}
							}

						});

						var runLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								reportToolbar,
								runGrid,
								runPagingToolbar
							]
						});							
						
						runWin.addToContentElement(runLayout);
						
						var actionRefreshRuns = function() {
							runPagingToolbar.loadPage(1);
						};
						
						var actionNewRun = function() {

							var runPromptWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Run Options',
								icon: 'vaadin:edit',
								width: 600,
								height: 300,
								listeners: {
									ready: function() {										
										runPromptWin.show();
										
										var reportIntervalMessage = '<vaadin-icon icon="vaadin:info-circle"></vaadin-icon>';
										if (record.closeReportInterval === 'MONTHLY') {
											reportIntervalMessage += ' Runs for the Previous Month';
										} else if (record.closeReportInterval === 'QUARTERLY') {
											reportIntervalMessage += ' Runs for the Previous Quarter';
										} else {
											reportIntervalMessage += ' Runs for the Previous Year';
										}										
										
										var formPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'div',
													style: 'text-align: center;',
													'class': 'alert alert-info',
													innerHTML: reportIntervalMessage
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-text-field',
															name: 'comment',
															label: 'Comment',														
															maxLength: 255
														},
														{
															tag: 'vaadin-checkbox',
															name: 'emailWhenComplete',
															checked: true,
															label: 'Email When Complete'
														},
														{
															tag: 'vaadin-checkbox',
															name: 'lockPeriodWhenComplete',
															checked: true,
															label: 'Lock Period When Complete'
														},
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:play', ' Run')
																	],
																	listeners: {
																		click: function () {

																			formPanel.submitForm({
																				preSubmit: function (data) {
																					return data;
																				},
																				actualCall: function (data) {																				
																					data.closeReportSetId = record.closeReportSetId;
																					return Service.getReportService().createNewRun(data.closeReportSetId, data);
																				},
																				success: function (data, responseData) {
																					window.DL.MessageUtil.showToast('Success', 'Submitted Close Reports Task', {
																						theme: 'success',
																						position: 'top-stretch'
																					});
																					actionRefreshRuns();
																					runPromptWin.close();
																				}
																			});

																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			//cancel
																			runPromptWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});

										runPromptWin.addToContentElement(formPanel);
									}
								}
							});
						};
										
						var actionViewDetails = function(run) {
														
							var detailsWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Run Details',
								icon: 'vaadin:form',
								width: .70,
								height: .70,
								listeners: {
									ready: function() {
										detailsWin.show();
										
										var detailToolbar = ElementUtil.create({
											tag: 'dl-toolbar',
											slot: 'toolbar',
											theme: 'spacing',
											children: [
												{
													tag: 'vaadin-button',
													itemid: 'refresh',
													'class': 'spacer-toolbar-item',
													children: [
														ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
													],
													listeners: {
														click: function () {
															actionRefreshDetails();
														}
													}
												},
												{
													tag: 'dl-action-button',
													itemid: 'download',
													theme: 'primary',
													'class': 'spacer-toolbar-item',
													permissions: ['CLOSE_REPORTS:READ'],
													children: [
														ElementUtil.makeIcon('vaadin:download', ' Download')
													],
													listeners: {
														click: function () {
															actionDownload(detailGrid.selectedItems[0]);
														}
													}
												},
												{
													tag: 'dl-action-button',
													itemid: 'view',
													'class': 'spacer-toolbar-item',
													permissions: ['CLOSE_REPORTS:READ'],
													children: [
														ElementUtil.makeIcon('vaadin:file-text', ' View Details')
													],
													listeners: {
														click: function () {
															actionViewReportDetails(detailGrid.selectedItems[0]);
														}
													}
												}
											]
										});

										var detailGrid = ElementUtil.create({
											tag: 'vaadin-grid',
											theme: 'row-stripes column-borders',
											'column-reordering-allowed': '',
											style: 'height: 100%;',
											slot: 'primary',
											defaults: {
												tag: 'vaadin-grid-sort-column',
												resizable: true,
												listeners: {
													'direction-changed': function (event) {
														if (event.detail && event.detail.value) {
															detailGrid.currentSortField = event.target.path;
															detailGrid.currentSortDirection = event.detail.value.toUpperCase();
														}
													}
												}
											},
											children: [
												{
													path: 'reportTypeDescription',
													header: 'Report',
													width: '7em'
												},
												{
													path: 'reportStatus',
													header: 'Status',
													'text-align': 'center',
													width: '7em'
												},
												{
													path: 'attachReport',
													header: 'Attached Report',
													'text-align': 'center',
													width: '7em'
												}
											],
											listeners: {
												'active-item-changed': function (event) {
													const item = event.detail.value;
													detailGrid.selectedItems = item ? [item] : [];
													if (detailGrid.selectedItems.length > 0) {
														ElementUtil.query(detailToolbar, 'view').disabled = false;
														ElementUtil.query(detailToolbar, 'download').disabled = false;														
													} else {
														ElementUtil.query(detailToolbar, 'view').disabled = true;
														ElementUtil.query(detailToolbar, 'download').disabled = true;													
													}
												}
											}
										});

										var detailFlexLayout = ElementUtil.create({
											tag: 'dl-flex-layout',
											children: [
												detailToolbar,
												detailGrid
											]
										});
										detailsWin.addToContentElement(detailFlexLayout);
										
										var actionRefreshDetails = function() {
											var loadMask = detailGrid.showLoading();
											Service.getReportService().getCloseReportRunDetail(run.closeReportSetId, run.runHistoryId).then(function(data){
												loadMask.remove();
												
												detailGrid.activeItem = null;															
												detailGrid.items = data;												
											});
										};
										actionRefreshDetails();
										
										var actionDownload = function(selectedDetail) {											
											if (selectedDetail.reportInEndState) {
												Service.getReportService().downloadCloseReport(run.closeReportSetId, run.runHistoryId, selectedDetail.reportHistoryId); 
											} else {
												window.DL.MessageUtil.showToastError('Report is not in a completed state.');
											}
										};
										
										var actionViewReportDetails = function(selectedDetail) {
											ReportTools.viewReportDetails(function (updateHandler) {
												Service.getReportService().getReportDetailOnRun(run.closeReportSetId, run.runHistoryId, selectedDetail.reportHistoryId).then(function(details) {
													updateHandler(details);
												});
											}, function (successHandler, unitFilter) {
												Service.getReportService().getReportDetailOnRunUnits(run.closeReportSetId, run.runHistoryId, selectedDetail.reportHistoryId, unitFilter).then(function (records) {
													successHandler(records);
												});
											}, selectedDetail.reportHistoryId, function (successHandler, groupFilter) {
												Service.getReportService().getReportDetailOnRunBulkGroups(run.closeReportSetId, run.runHistoryId, selectedDetail.reportHistoryId, groupFilter).then(function (records) {
													successHandler(records);
												});
											});
										};
										
									}
								}
							});
							
						};
												
					}
				}
			});			
		};		
		
	}
	
}
customElements.define('dl-closereports-grid', CloseReportsGrid);
